import { render, staticRenderFns } from "./company.vue?vue&type=template&id=637cdc0d&scoped=true&"
var script = {}
import style0 from "./company.vue?vue&type=style&index=0&id=637cdc0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637cdc0d",
  null
  
)

export default component.exports